import { AvatarGroup, AvatarGroupProps, AvatarProps } from "@chakra-ui/react"
import { Fragment } from "react"
import UserAvatar from "./UserAvatar"
import { AvatarUser } from "./types"

type UserAvatarStackProps = {
  users: AvatarUser[]
  // Used to calculate excess avatars in edge cases.
  total?: number
  max?: AvatarGroupProps["max"]
} & AvatarProps

// Dumb component that accepts the group.
export const UserAvatarStack = ({
  users,
  total,
  max,
  ...avatarProps
}: UserAvatarStackProps) => {
  // Chakra UI controls the excess count and bases it off of the number
  // of children beyond the max prop, so we have to manually render the
  // excess children. Whoopee.
  const excessAvatars = new Array(
    Math.max((total || users.length) - users.length, 0)
  ).fill(null)

  max ??= 3

  return users.length ? (
    <AvatarGroup size="xs" max={max} spacing={-1}>
      {users.map((user) => (
        <UserAvatar
          key={user.id}
          user={user}
          color="white"
          borderWidth={0}
          {...avatarProps}
        />
      ))}
      {excessAvatars.map((_, i) => (
        <Fragment key={i} />
      ))}
    </AvatarGroup>
  ) : null
}

export default UserAvatarStack
